import { render, staticRenderFns } from "./GroupContactsPage.vue?vue&type=template&id=1c3288e1&scoped=true&"
import script from "./GroupContactsPage.vue?vue&type=script&lang=js&"
export * from "./GroupContactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3288e1",
  null
  
)

export default component.exports